module.exports = __webpack_public_path__ + "static/media/YF12_2.fe6df8cb.jpg";